import { createAction } from "@ngrx/store";

export const invokeCalendarLaunch = createAction(
  "[ Invoke calendar launch ] Invoke calendar launch"
);

export const resultCalendarLaunch = createAction(
  "[ Result calendar launch ] Result calendar launch"
);
